import { render, staticRenderFns } from "./SelfscanningListSelector.vue?vue&type=template&id=6b5435d5"
import script from "./SelfscanningListSelector.vue?vue&type=script&lang=js"
export * from "./SelfscanningListSelector.vue?vue&type=script&lang=js"
import style0 from "./SelfscanningListSelector.vue?vue&type=style&index=0&id=6b5435d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports